import SaleReturnList from "./SaleReturnList";
const SaleReturnRoutes = [
  {
    path: "/saleReturn/saleReturn-list",
    component: SaleReturnList,
    permission: "Permissions.SaleReturns.View",
  },
];
export default SaleReturnRoutes;
